import { render, staticRenderFns } from "./Viewper.vue?vue&type=template&id=dbf65332&scoped=true"
import script from "./Viewper.vue?vue&type=script&lang=js"
export * from "./Viewper.vue?vue&type=script&lang=js"
import style0 from "./Viewper.vue?vue&type=style&index=0&id=dbf65332&prod&scoped=true&lang=css"
import style1 from "./Viewper.vue?vue&type=style&index=1&id=dbf65332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf65332",
  null
  
)

export default component.exports